$shm_hitalama_file_attach $mol_view
	value? \
	event *
		^
		dragover? <=> file_dragover? null
		drop? <=> file_drop? null
	sub /
		<= File $shm_file_drop
			files? <=> files? /
		<= Name $mol_paragraph
			title <= filename \
		^ delete_visible /
			<= Delete_row $mol_view
				sub /
					<= Delete $mol_button_minor
						title \Удалить файл
						click? <=> file_delete? null
